import { render, staticRenderFns } from "./AddRights.vue?vue&type=template&id=bc3bbb6a&"
import script from "./AddRights.vue?vue&type=script&lang=js&"
export * from "./AddRights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc3bbb6a')) {
      api.createRecord('bc3bbb6a', component.options)
    } else {
      api.reload('bc3bbb6a', component.options)
    }
    module.hot.accept("./AddRights.vue?vue&type=template&id=bc3bbb6a&", function () {
      api.rerender('bc3bbb6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/AddRights.vue"
export default component.exports